import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import AppCardSeo from "@/components/AppCardSeo";
import AppInput from "@/components/AppInput";
import AppIcon from "@/components/AppIcon";
import AppPagination from "@/components/AppPagination";
import SeoTopSection from "@/components/SeoTopSection";
import ContentMixin from "@/mixins/ContentMixin.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import ContentDisplayRulesMixin from "@/mixins/ContentDisplayRulesMixin.vue";
import { filterOut, EVENTS } from "@/utils";
import { FilterManager } from "@/store/filter";
import { FILTER_KEYS } from "@/utils/constants";
import ContentOptimisationTableNew from "../components/seo/ContentOptimisationTableNew.vue";
import ContentOptimisationTableNewWithParents from "../components/seo/ContentOptimisationTableNewWithParents.vue";
import ContentExportDropDown from "@/components/ContentExportDropDown.vue";
import SeoPushStatusFilter from "@/components/SeoPushStatusFilter.vue";
import SeoBulkModal from "@/components/SeoBulkModal.vue";
export default {
  name: "SEOPage",
  mixins: [ContentMixin, DownloadMixin, ContentDisplayRulesMixin],
  components: {
    AppCardSeo,
    AppIcon,
    AppInput,
    AppPagination,
    SeoTopSection,
    ContentOptimisationTableNew,
    ContentOptimisationTableNewWithParents,
    ContentExportDropDown,
    SeoPushStatusFilter,
    SeoBulkModal
  },
  data() {
    return {
      dataLoading: false,
      hideNavigationTabs: false,
      search: "",
      editSingleItem: false,
      downloadParamPerPage: 20,
      //let's keep it 20 as each content is big per page.
      selectedOption: null,
      isDownloadRunning: false,
      isFilterReady: false,
      isBulkOpen: false,
      pushStatusList: {
        draft: [],
        sync_error: []
      },
      pushStatusFilters: [{
        status: "draft",
        statusClass: "draft",
        icon: "draft-status",
        iconSize: 12,
        iconHoverColor: "#5a52ae",
        iconDefaultColor: "#736bc9"
      }, {
        status: "sync_error",
        statusClass: "sync-error",
        icon: "sync-error-status",
        iconSize: 14,
        iconHoverColor: "#ad1f25",
        iconDefaultColor: "#db333b"
      }]
    };
  },
  computed: {
    ...mapGetters(["contentGetByPushStatus", "contentFiltersSelectedGet"]),
    ...mapState({
      pushModal: state => state.content.pushModal,
      sellers_filter: state => state.content.sellers_filter,
      marketplaces_filter: state => state.content.marketplaces_filter,
      products_filter: state => state.content.products_filter,
      segments_filter: state => state.content.segments_filter,
      total_count: state => state.content.total_count,
      page: state => state.content.page,
      perPage: state => state.content.perPage,
      current_workspace: state => state.workspace.current_workspace,
      modified_list: state => state.content.modified_list
    }),
    sellersFromFilter() {
      return this.sellers_filter;
    },
    currentTotal() {
      return this.currentTab === "content_optimisation_with_parent" ? this.totalCountForParentViewGet() : this.totalCountGet();
    }
  },
  async mounted() {
    await this.refreshSellers();
    await this.initializeKeywordsListFilter(this.contentsKeyWordListSet, "contentsKeyWordList");
    this.search = this.keyword_list.length > 0 ? this.keyword_list.join(",") : this.search;
    const filterManager = new FilterManager({
      sellersFilter: this.sellers_filter,
      marketplacesFilter: this.marketplaces_filter,
      rootPath: "content"
    });
    filterManager.registerAll({
      [FILTER_KEYS.SEGMENTS]: {
        storeFilter: this.segments_filter,
        initializer: this.initializeSegmentsFilter
      }
    });
    filterManager.refreshAllBackground();

    // Refetch the segments filter whenever the seller selection changes.
    window.$bus.on(EVENTS.REFRESH_SEO_PAGE_SELLERS_SUB_FILTERS, () => filterManager.refreshSet([FILTER_KEYS.SEGMENTS]));
    this.isFilterReady = true;
    this.onInitializationFinished();
    //this.pushStatusList["draft"] = this.contentGetByPushStatus("draft");
    //this.pushStatusList["sync_error"] = this.contentGetByPushStatus("sync_error");
  },
  methods: {
    ...mapMutations(["contentPageSet", "contentPerPageSet", "contentsKeyWordListSet", "contentPushStatusSelectedReset", "contentSelectedContentsSet"]),
    ...mapActions(["contentModifiedList", "contentIdGetByModifiedId"]),
    handleError() {
      //console.log("Error");
    },
    pushStatusListForStatus(status) {
      return this.pushStatusList[status?.status] ?? [];
    },
    onBulkOpen() {
      this.isBulkOpen = true;
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: "userOpenedBulkEditPanel",
        properties: {}
      });
    },
    async changePage(newPage) {
      this.contentPageSet(newPage);
      await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
    },
    async changeElements(elementsPerPage) {
      this.contentPageSet(1);
      this.contentPerPageSet(elementsPerPage);
      await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
    },
    onResetPagingValues() {
      this.contentPageSet(1);
      this.contentPerPageSet(20);
    },
    onDataLoading($event) {
      this.dataLoading = $event;
    },
    onEditSingleItem($event) {
      this.editSingleItem = $event;
    },
    onPushStatusList($event) {
      this.pushStatusList = $event;
    },
    async onPushModalCancel($event) {
      this.hideNavigationTabs = false;
      await window.$bus.trigger(EVENTS.SEO_PUSH_MODAL_CANCEL);
    },
    async onPushModalSubmitModifiedContents($event) {
      this.hideNavigationTabs = false;
      await window.$bus.trigger(EVENTS.SEO_PUSH_MODAL_SUBMIT_MODIFIED_CONTENT);
    },
    async onPushModal($event) {
      this.hideNavigationTabs = true;
      await window.$bus.trigger(EVENTS.SEO_PUSH_MODAL_OPEN);
    },
    onChangeTab($event) {
      this.contentSelectedContentsSet([]);
    },
    async searchItem($event) {
      const value = $event.split(",").filter(v => !!v).map(element => element.trim());
      this.contentsKeyWordListSet(value);
      this.saveKeyWordListToCache(value);
      await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS);
    },
    async onInitializationFinished() {
      this.contentPushStatusSelectedReset();
      /* const modified_list = await this.contentModifiedList({
        seller_list: this.sellersFromFilter.filterValues,
      });
      if (modified_list.data?.length > 0) {
        await this.contentIdGetByModifiedId({
          ...this.contentFiltersSelectedGet(),
          ...{ content_id_list: modified_list.data },
        });
      }*/
      this.dataLoading = false;
    },
    getHeadersforMappingContentDataCSV() {
      let headersMapping = {
        seller_id: "seller_id",
        seller_name: "seller_name",
        marketplace_id: "marketplace_id",
        country_code: "country_code",
        sku: "sku",
        asin: "asin",
        image_small: "image_small",
        listing_status: "listing_status",
        count_images: "count_images",
        brand: "brand",
        category_id: "category_id",
        category_name: "category_name",
        product_type: "product_type",
        product_name: "product_name",
        item_highlight: "item_highlight",
        generic_keyword: "generic_keyword",
        product_description: "product_description",
        bullet_point_1: "bullet_point_1",
        bullet_point_2: "bullet_point_2",
        bullet_point_3: "bullet_point_3",
        bullet_point_4: "bullet_point_4",
        bullet_point_5: "bullet_point_5",
        amazon_score: "amazon_score",
        omny_score: "omny_score",
        push_status: "",
        last_push_date: "last_push_date"
      };
      return this.extractHeadersContentDataCSV(headersMapping);
    }
  }
};